export default function ({ redirect, localePath, route }) {
    // these are meant to redirect from already non-existent pages
    if (/(faq)$/.test(route.path)) {
        return redirect(localePath('/help'));
    }
    if (/(employment-information)$/.test(route.path)) {
        return redirect(localePath('/user/personal-information'));
    }
}
